var map = {
	"./Coupon/Validation": [
		71,
		17
	],
	"./Coupon/Validation.vue": [
		71,
		17
	],
	"./Ecommerce/LegalInfo": [
		72,
		1,
		2,
		0,
		3,
		25
	],
	"./Ecommerce/LegalInfo.vue": [
		72,
		1,
		2,
		0,
		3,
		25
	],
	"./Error/BasicError": [
		73,
		26
	],
	"./Error/BasicError.vue": [
		73,
		26
	],
	"./Error/Error": [
		74,
		1,
		2,
		0,
		3,
		27
	],
	"./Error/Error.vue": [
		74,
		1,
		2,
		0,
		3,
		27
	],
	"./Shared/Inventory/ItemPurchaseValidation": [
		75,
		28
	],
	"./Shared/Inventory/ItemPurchaseValidation.vue": [
		75,
		28
	],
	"./Shared/Layouts/Template1": [
		7,
		1,
		2,
		0,
		13
	],
	"./Shared/Layouts/Template1.vue": [
		7,
		1,
		2,
		0,
		13
	],
	"./Shared/Layouts/Template2": [
		9,
		1,
		0,
		32
	],
	"./Shared/Layouts/Template2.vue": [
		9,
		1,
		0,
		32
	],
	"./Sindyk/PlanPurchaseValidation": [
		76,
		31
	],
	"./Sindyk/PlanPurchaseValidation.vue": [
		76,
		31
	],
	"./Template1/Home/Index": [
		61,
		1,
		2,
		0,
		3,
		23
	],
	"./Template1/Home/Index.vue": [
		61,
		1,
		2,
		0,
		3,
		23
	],
	"./Template1/Inventory/Categories": [
		77,
		1,
		2,
		0,
		3,
		18
	],
	"./Template1/Inventory/Categories.vue": [
		77,
		1,
		2,
		0,
		3,
		18
	],
	"./Template1/Inventory/Item": [
		63,
		1,
		2,
		0,
		3,
		24
	],
	"./Template1/Inventory/Item.vue": [
		63,
		1,
		2,
		0,
		3,
		24
	],
	"./Template1/Inventory/Search": [
		78,
		1,
		2,
		0,
		3,
		19
	],
	"./Template1/Inventory/Search.vue": [
		78,
		1,
		2,
		0,
		3,
		19
	],
	"./Template1/Inventory/Subcategories": [
		79,
		1,
		2,
		0,
		3,
		20
	],
	"./Template1/Inventory/Subcategories.vue": [
		79,
		1,
		2,
		0,
		3,
		20
	],
	"./Template1/Shopping/Cart": [
		60,
		1,
		2,
		0,
		3,
		12
	],
	"./Template1/Shopping/Cart.vue": [
		60,
		1,
		2,
		0,
		3,
		12
	],
	"./Template1/Shopping/Checkout": [
		64,
		1,
		2,
		4,
		0,
		7
	],
	"./Template1/Shopping/Checkout.vue": [
		64,
		1,
		2,
		4,
		0,
		7
	],
	"./Template1/Shopping/PaymentStatus": [
		65,
		1,
		2,
		0,
		3,
		16
	],
	"./Template1/Shopping/PaymentStatus.vue": [
		65,
		1,
		2,
		0,
		3,
		16
	],
	"./Template1/User/DataVerification": [
		66,
		1,
		2,
		0,
		3,
		11
	],
	"./Template1/User/DataVerification.vue": [
		66,
		1,
		2,
		0,
		3,
		11
	],
	"./Template1/User/Login": [
		67,
		1,
		2,
		4,
		0,
		8
	],
	"./Template1/User/Login.vue": [
		67,
		1,
		2,
		4,
		0,
		8
	],
	"./Template1/User/Register": [
		68,
		1,
		2,
		4,
		0,
		6
	],
	"./Template1/User/Register.vue": [
		68,
		1,
		2,
		4,
		0,
		6
	],
	"./Template2/Home/Index": [
		62,
		1,
		0,
		14
	],
	"./Template2/Home/Index.vue": [
		62,
		1,
		0,
		14
	],
	"./Template2/Inventory/Hidden": [
		80,
		1,
		0,
		21
	],
	"./Template2/Inventory/Hidden.vue": [
		80,
		1,
		0,
		21
	],
	"./Template2/Shopping/Checkout": [
		81,
		1,
		0,
		5,
		22
	],
	"./Template2/Shopping/Checkout.vue": [
		81,
		1,
		0,
		5,
		22
	],
	"./Template2/User/Login": [
		82,
		1,
		0,
		5,
		15
	],
	"./Template2/User/Login.vue": [
		82,
		1,
		0,
		5,
		15
	],
	"./Template2/User/LoginOptions": [
		83,
		1,
		0,
		5,
		33
	],
	"./Template2/User/LoginOptions.vue": [
		83,
		1,
		0,
		5,
		33
	],
	"./Template2/User/Register": [
		59,
		1,
		4,
		0,
		5,
		10
	],
	"./Template2/User/Register.vue": [
		59,
		1,
		4,
		0,
		5,
		10
	],
	"./Template2/User/SetPassword": [
		69,
		1,
		0,
		29
	],
	"./Template2/User/SetPassword.vue": [
		69,
		1,
		0,
		29
	],
	"./User/Account": [
		58,
		1,
		2,
		4,
		0,
		9
	],
	"./User/Account.vue": [
		58,
		1,
		2,
		4,
		0,
		9
	],
	"./User/RestorePassword": [
		70,
		1,
		2,
		0,
		3,
		30
	],
	"./User/RestorePassword.vue": [
		70,
		1,
		2,
		0,
		3,
		30
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 172;
module.exports = webpackAsyncContext;